import { AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios';
import { Graphback } from '../graphback';

/**
 * A GraphQL failure carrying the server's `extensions.code`. A plain `Error`
 * with one added property rather than a subclass, so every `instanceof Error`
 * and `message` caller is untouched.
 */
export type GraphQLRequestError = Error & { code?: string };

/** The server's `extensions.code`, when the throw came from one. */
export const graphQLErrorCode = (error: unknown): string | undefined =>
  error instanceof Error ? (error as GraphQLRequestError).code : undefined;

export const useFetcher = <TData, TVariables>(
  query: string,
  options?: RequestInit['headers']
): ((variables?: TVariables) => Promise<TData>) => {
  let config: Partial<AxiosRequestConfig>;

  if (options) {
    const headers = { ...options } as RawAxiosRequestHeaders;
    config = {
      headers,
    };
  }

  return async (variables?: TVariables) => {
    const res = await Graphback.getInstance().post(
      '',
      { query, variables },
      config
    );

    const json = res.data;

    if (json.errors) {
      const { message, extensions } = (json.errors[0] || {}) as {
        message?: string;
        extensions?: { code?: string };
      };
      const error: GraphQLRequestError = new Error(message || 'Error…');
      if (extensions?.code) error.code = extensions.code;
      throw error;
    }

    return json.data;
  };
};
